// extracted by mini-css-extract-plugin
export default {"section":"tu-z","inSectionButton":"uu-z","addressCard":"vu-z","disabled":"wu-z","cautionBox":"xu-z","failureBox":"yu-z","fade-out":"zu-z","successBox":"Au-z"};